import { Box } from "@mui/material";

export default function AppContentWrapper({
  children,
  padding = true,
  gap = 3,
  scrollable = true, // ✅ NEW PROP (default = true)
}) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        minHeight: 0, //✅ allow shrinking

        // ✅ conditional scrolling
        ...(scrollable && {
          overflowY: "auto",
        }),
        display: "flex",
        flexDirection: "column",
        gap: gap,

        px: padding ? { xs: 1, sm: 2 } : 0,
        py: padding ? { xs: 1, sm: 2 } : 0,
      }}
    >
      {children}
    </Box>
  );
}
